import PropTypes from 'prop-types';
import Modal from 'react-modal';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';
import Link from 'components/hf/HFLink';

import css from 'styles/components/hf/signUpModal.scss';
import modalCSS from 'styles/components/common/modal.scss';

const rewardsheadingFallback = 'Give me FREE Next Business Day Shipping on every order and more!';
const rewardscopyFallback = 'Sign me up for Zappos VIP. It’s FREE!';
const emailheadingFallback = 'Be the first to know about exclusive offers and new arrivals!';
const emailcopyFallback = 'Sign me up for Zappos emails.';
const headingFallback = 'Thanks for coming to our party!';

const SignUpModal = ({ data, setSignUpModal, isSignUpModalOpen, handleSignUpModalSubmit }) => {
  const { testId, marketplace: { features: { showAccountRewards } } } = useMartyContext();

  if (data && data.componentName === 'melodySignUpModal') {
    const { rewardsheading, cta, emailheading, heading, emailcopy, rewardscopy } = data;

    return (
      <Modal
        ariaHideApp={true}
        aria-describedby="modalDescription"
        bodyOpenClassName={css.fix}
        className={cn(modalCSS.modalContent, css.modalContent, { [css.fade]: true })}
        contentLabel="Email Subscriptions"
        data-test-id={testId('headerFooterSignUpModal')}
        isOpen={isSignUpModalOpen}
        onRequestClose={() => setSignUpModal(false)}
        overlayClassName={modalCSS.modalOverlay}>
        <form method="post" className={css.mSignUpModal} onSubmit={handleSignUpModalSubmit}>
          <div className={modalCSS.header}>
            <h2 id="modalDescription">{heading || headingFallback}</h2>
            <button
              aria-label="Close"
              className={modalCSS.close}
              data-test-id={testId('closeModal')}
              onClick={() => setSignUpModal(false)}
              type="button" />
          </div>
          <div className={css.content}>
            {showAccountRewards &&
              <div className={css.selectionBlock}>
                <input type="checkbox" id="signupModalRewards" name="rewards"/>
                <label htmlFor="signupModalRewards">
                  <div>
                    <p className={css.contentHeading}>{rewardsheading || rewardsheadingFallback}</p>
                    <p className={css.contentCopy}>{rewardscopy || rewardscopyFallback} I agree to the <Link to="/c/vip-terms-and-conditions" target="_blank">terms and conditions</Link></p>
                  </div>
                </label>
              </div>
            }
            {
              <div className={css.selectionBlock}>
                <input
                  defaultChecked={true}
                  id="signupModalEmail"
                  name="email"
                  type="checkbox" />
                <label htmlFor="signupModalEmail">
                  <div>
                    <p className={css.contentHeading}>{emailheading || emailheadingFallback}</p>
                    <p className={css.contentCopy}>{emailcopy || emailcopyFallback}</p>
                  </div>
                </label>
              </div>
            }
          </div>
          <div className={css.footer}>
            <button
              className={css.btn}
              type="submit"
              data-test-id={testId('signupBtn')}>{cta || 'Submit'}</button>
          </div>
        </form>
      </Modal>
    );
  }
  return null;
};

SignUpModal.propTypes = {
  data: PropTypes.object,
  setSignUpModal: PropTypes.func.isRequired,
  isSignUpModalOpen: PropTypes.bool.isRequired,
  handleSignUpModalSubmit: PropTypes.func.isRequired
};

export default SignUpModal;
